import { useSelector } from "react-redux";
import { selectCurrentUser } from "../store/auth.duck";
import { useMemo } from "react";

export function IsSuperAdmin() {
  const current = useSelector(selectCurrentUser);

  const superAdminButtonsEnabled = useMemo(() => {
    if (!current || !current.email) return false;
    return ['robin@team-today.com', 'lucy@team-today.com', 'andrew@team-today.com', 'andrew@team-tracker.com'].includes(current.email);
  }, [current]);

  return superAdminButtonsEnabled;
}
